import { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

interface IProps {
  load: any;
}

export const ResidueData: FC<IProps> = ({ load }) => {
  const { t } = useTranslation();

  const list = useMemo(() => {
    return [
      {
        title: t('physical.weight'),
        value: load?.weight ? `${load?.weight} kg` : '---',
        span: 'col-span-1',
      },
      {
        title: t(
          `${load?.weight - load?.weight_calc > 0 ? 'tare' : 'tare.description'}`,
        ),
        value: `${(load?.weight - load?.weight_calc).toFixed(2)} kg` || '---',
        span: 'col-span-1',
      },
      // {
      //   title: t('gross.weight'),
      //   value: load?.weight_calc || '---',
      //   span: 'col-span-2',
      // },
      {
        title: t(
          `${load?.weight_calc - load?.weight_cond > 0 ? 'conditional.weight.cost' : 'conditional.weight.description'}`,
        ),
        value:
          `${(load?.weight_calc - load?.weight_cond).toFixed(2)} kg` || '---',
        span: 'col-span-1',
      },
      {
        title: t('conditional.weight'),
        value: load?.weight_cond ? `${load?.weight_cond} kg` : '---',
        span: 'col-span-1',
      },
    ];
  }, [load]);

  return (
    <div className="border-t border-gray-300 pt-8 mt-4">
      <h3 className="text-lg font-medium mb-4">{t('current.weight')}</h3>
      <div className="grid grid-cols-4 gap-6 w-full">
        {list?.map((item) => (
          <div key={item.title} className={item.span}>
            <p className="text-sm text-gray-600 mb-1">{item.title}:</p>
            <p className="text-base font-medium">{item.value}</p>
          </div>
        ))}
      </div>
    </div>
  );
};
